const baseService = 'https://back.skygroupinvictus.com.ve';
const wsService = 'http://localhost:8443';

export { wsService, baseService };
export default baseService; 